var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Handles selection when clicked on a checkbox.
 */
export var onSelectHandler = function (newState, instance, onSelect, isRowDisabled) {
    if (!(instance === null || instance === void 0 ? void 0 : instance.rows.length)) {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect([], newState);
        return;
    }
    var newSelectedRowIds = {};
    var handleRow = function (row) {
        if (isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled(row.original)) {
            return false;
        }
        var isAllSubSelected = true;
        row.initialSubRows.forEach(function (subRow) {
            var result = handleRow(subRow);
            if (!result) {
                isAllSubSelected = false;
            }
        });
        // If `selectSubRows` is false, then no need to select sub-rows and just check current selection state.
        // If a row doesn't have sub-rows then check its selection state.
        // If it has sub-rows then check whether all of them are selected.
        if ((!instance.selectSubRows && newState.selectedRowIds[row.id]) ||
            (!row.initialSubRows.length && newState.selectedRowIds[row.id]) ||
            (row.initialSubRows.length && isAllSubSelected)) {
            newSelectedRowIds[row.id] = true;
        }
        return !!newSelectedRowIds[row.id];
    };
    instance.initialRows.forEach(function (row) { return handleRow(row); });
    var selectedData = getSelectedData(newSelectedRowIds, instance);
    newState.selectedRowIds = newSelectedRowIds;
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedData, newState);
};
/**
 * Handles selection when clicked on a row.
 */
export var onSingleSelectHandler = function (state, action, instance, onSelect, isRowDisabled) {
    var _a;
    var selectedRowIds = (_a = {}, _a[action.id] = true, _a);
    if (instance === null || instance === void 0 ? void 0 : instance.selectSubRows) {
        var handleRow_1 = function (row) {
            selectedRowIds[row.id] = true;
            row.subRows.forEach(function (r) { return handleRow_1(r); });
        };
        handleRow_1(instance.rowsById[action.id]);
    }
    var newState = __assign(__assign({}, state), { selectedRowIds: selectedRowIds });
    // Passing to `onSelectHandler` to handle filtered sub-rows
    onSelectHandler(newState, instance, onSelect, isRowDisabled);
    return newState;
};
var getSelectedData = function (selectedRowIds, instance) {
    var selectedData = [];
    var setSelectedData = function (row) {
        if (selectedRowIds[row.id]) {
            selectedData.push(row.original);
        }
        row.initialSubRows.forEach(function (subRow) { return setSelectedData(subRow); });
    };
    instance === null || instance === void 0 ? void 0 : instance.initialRows.forEach(function (row) { return setSelectedData(row); });
    return selectedData;
};
